import { useState, useEffect, useRef } from "react";
import "../styles/Testimonials.css"

const REVIEWS = [
    {
        name: "Priya Anand",
        avatar: "PA",
        rating: 5,
        date: "2 weeks ago",
        text: "Absolutely stunning experience at King & Queen! My bridal makeup was flawless — I cried happy tears when I saw myself. The team understood exactly the look I wanted and elevated it beyond my imagination.",
        service: "Bridal Makeup",
    },
    {
        name: "Rahul Krishnan",
        avatar: "RK",
        rating: 5,
        date: "1 month ago",
        text: "Best beard grooming in Salem, hands down. The precision shaping and the hot towel finish made me feel like royalty. I've tried many salons but King & Queen is on another level entirely.",
        service: "Beard Grooming",
    },
    {
        name: "Divya Sundar",
        avatar: "DS",
        rating: 5,
        date: "3 weeks ago",
        text: "My skin has never looked better. The facial treatment they recommended was deeply rejuvenating. The staff is knowledgeable, warm, and genuinely passionate about their craft. Will not go anywhere else!",
        service: "Skin Care",
    },
    {
        name: "Arun Murugan",
        avatar: "AM",
        rating: 5,
        date: "2 months ago",
        text: "Brought my whole family here for a special occasion haircut and styling session. Every single person left feeling transformed. The ambience alone is worth the visit — pure luxury in Salem.",
        service: "Hair Styling",
    },
    {
        name: "Kavitha Rajan",
        avatar: "KR",
        rating: 5,
        date: "5 weeks ago",
        text: "From the moment I stepped in, the calm and elegance of the salon set me at ease. The hair treatment completely restored my damaged hair. I walked out feeling like the queen the salon is named for!",
        service: "Hair Treatment",
    },
    {
        name: "Santhosh Vel",
        avatar: "SV",
        rating: 5,
        date: "1 month ago",
        text: "Exceptional service, exceptional team. My haircut and styling was done with such precision and care. They listened to what I wanted and delivered perfection. This is now my go-to salon in Salem.",
        service: "Hair Styling",
    },
];

const StarRating = ({ rating }) => (
    <div className="kq-stars">
        {[1, 2, 3, 4, 5].map((s) => (
            <svg
                key={s}
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill={s <= rating ? "var(--gold)" : "none"}
                stroke={s <= rating ? "var(--gold)" : "var(--warm-grey)"}
                strokeWidth="1.5"
            >
                <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
            </svg>
        ))}
    </div>
);

const GOOGLE_MAPS_URL = "https://maps.app.goo.gl/43owq3qMRjBZRtx46";
const OVERALL_RATING = 4.9;
const TOTAL_REVIEWS = 120;

export default function Testimonials() {
    const [active, setActive] = useState(0);
    const [animating, setAnimating] = useState(false);
    const [paused, setPaused] = useState(false);
    const intervalRef = useRef(null);

    const goTo = (idx) => {
        if (animating || idx === active) return;
        setAnimating(true);
        setTimeout(() => {
            setActive(idx);
            setAnimating(false);
        }, 350);
    };

    const next = () => goTo((active + 1) % REVIEWS.length);
    const prev = () => goTo((active - 1 + REVIEWS.length) % REVIEWS.length);

    useEffect(() => {
        if (!paused) {
            intervalRef.current = setInterval(next, 5000);
        }
        return () => clearInterval(intervalRef.current);
    }, [active, paused]);

    const r = REVIEWS[active];

    return (
        <>
            <style>{`
                /* ── TESTIMONIALS ─────────────────────────────────── */
                .kq-testimonials {
                    padding: 110px 7%;
                    background: var(--black);
                    position: relative;
                    overflow: hidden;
                }

                /* decorative corner filigree */
                .kq-testi-deco {
                    position: absolute;
                    top: 0; left: 0;
                    width: 340px; height: 340px;
                    opacity: 0.04;
                    pointer-events: none;
                }
                .kq-testi-deco-br {
                    top: auto; left: auto;
                    bottom: 0; right: 0;
                    transform: rotate(180deg);
                }

                .kq-testi-inner {
                    max-width: 1200px;
                    margin: 0 auto;
                }

                /* header row */
                .kq-testi-header {
                    display: flex;
                    align-items: flex-end;
                    justify-content: space-between;
                    margin-bottom: 64px;
                    flex-wrap: wrap;
                    gap: 24px;
                }

                .kq-testi-rating-badge {
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    background: rgba(201,169,110,0.08);
                    border: 1px solid rgba(201,169,110,0.2);
                    padding: 20px 28px;
                    border-radius: 2px;
                }

                .kq-testi-big-num {
                    font-family: var(--font-display);
                    font-size: 56px;
                    font-weight: 300;
                    color: var(--gold);
                    line-height: 1;
                    letter-spacing: -0.02em;
                }

                .kq-testi-badge-right {
                    display: flex;
                    flex-direction: column;
                    gap: 6px;
                }

                .kq-testi-badge-right .kq-stars {
                    display: flex;
                    gap: 3px;
                }

                .kq-testi-badge-sub {
                    font-size: 11px;
                    color: var(--warm-grey);
                    letter-spacing: 0.12em;
                    text-transform: uppercase;
                }

                .kq-testi-google-link {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    font-size: 11px;
                    letter-spacing: 0.18em;
                    text-transform: uppercase;
                    color: var(--gold);
                    text-decoration: none;
                    border-bottom: 1px solid rgba(201,169,110,0.3);
                    padding-bottom: 2px;
                    transition: border-color 0.3s;
                    margin-top: 8px;
                }
                .kq-testi-google-link:hover { border-color: var(--gold); }

                /* ── MAIN CARD STAGE ───────────────────────────────── */
                .kq-testi-stage {
                    display: grid;
                    grid-template-columns: 1fr 380px;
                    gap: 48px;
                    align-items: stretch;
                    margin-bottom: 48px;
                }

                .kq-testi-card {
                    position: relative;
                    background: rgba(255,255,255,0.03);
                    border: 1px solid rgba(201,169,110,0.15);
                    padding: 52px 56px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    min-height: 360px;
                    transition: opacity 0.35s ease, transform 0.35s ease;
                }

                .kq-testi-card.fade-out {
                    opacity: 0;
                    transform: translateY(12px);
                }

                /* big quote mark */
                .kq-testi-quote-icon {
                    position: absolute;
                    top: 32px;
                    right: 40px;
                    font-family: var(--font-display);
                    font-size: 120px;
                    line-height: 1;
                    color: rgba(201,169,110,0.12);
                    pointer-events: none;
                    font-style: italic;
                    user-select: none;
                }

                .kq-testi-text {
                    font-family: var(--font-display);
                    font-size: clamp(20px, 2vw, 28px);
                    font-weight: 300;
                    font-style: italic;
                    line-height: 1.65;
                    color: rgba(255,255,255,0.82);
                    margin: 0 0 40px;
                    position: relative;
                    z-index: 1;
                }

                .kq-testi-author {
                    display: flex;
                    align-items: center;
                    gap: 20px;
                }

                .kq-testi-avatar {
                    width: 52px; height: 52px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, var(--gold-dark), var(--gold));
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-family: var(--font-display);
                    font-size: 18px;
                    font-weight: 600;
                    color: var(--black);
                    flex-shrink: 0;
                    letter-spacing: 0.05em;
                }

                .kq-testi-author-info {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                }

                .kq-testi-name {
                    font-family: var(--font-body);
                    font-size: 15px;
                    font-weight: 500;
                    color: rgba(255,255,255,0.9);
                }

                .kq-testi-meta {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }

                .kq-testi-service-tag {
                    font-size: 10px;
                    letter-spacing: 0.15em;
                    text-transform: uppercase;
                    color: var(--gold);
                    background: rgba(201,169,110,0.1);
                    padding: 3px 10px;
                    border: 1px solid rgba(201,169,110,0.2);
                }

                .kq-testi-date {
                    font-size: 11px;
                    color: var(--warm-grey);
                    letter-spacing: 0.05em;
                }

                /* ── SIDE STACK (mini cards) ──────────────────────── */
                .kq-testi-sidebar {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                }

                .kq-testi-mini {
                    background: rgba(255,255,255,0.02);
                    border: 1px solid rgba(255,255,255,0.06);
                    padding: 18px 20px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    display: flex;
                    align-items: center;
                    gap: 14px;
                    position: relative;
                    overflow: hidden;
                }

                .kq-testi-mini::before {
                    content: '';
                    position: absolute;
                    left: 0; top: 0; bottom: 0;
                    width: 2px;
                    background: var(--gold);
                    transform: scaleY(0);
                    transition: transform 0.3s ease;
                    transform-origin: center;
                }

                .kq-testi-mini.active::before,
                .kq-testi-mini:hover::before { transform: scaleY(1); }

                .kq-testi-mini.active {
                    border-color: rgba(201,169,110,0.25);
                    background: rgba(201,169,110,0.05);
                }

                .kq-testi-mini-avatar {
                    width: 36px; height: 36px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, var(--gold-dark), var(--gold));
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 12px;
                    font-weight: 600;
                    color: var(--black);
                    flex-shrink: 0;
                }

                .kq-testi-mini-text {
                    flex: 1;
                    min-width: 0;
                }

                .kq-testi-mini-name {
                    font-size: 13px;
                    font-weight: 500;
                    color: rgba(255,255,255,0.8);
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .kq-testi-mini-snippet {
                    font-size: 11px;
                    color: var(--warm-grey);
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    margin-top: 2px;
                }

                /* ── CONTROLS ─────────────────────────────────────── */
                .kq-testi-controls {
                    display: flex;
                    align-items: center;
                    gap: 20px;
                }

                .kq-testi-arrow {
                    width: 48px; height: 48px;
                    border: 1px solid rgba(201,169,110,0.3);
                    background: transparent;
                    color: var(--gold);
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.3s ease;
                    flex-shrink: 0;
                }

                .kq-testi-arrow:hover {
                    background: var(--gold);
                    color: var(--black);
                    border-color: var(--gold);
                }

                .kq-testi-dots {
                    display: flex;
                    gap: 8px;
                    flex: 1;
                }

                .kq-testi-dot {
                    height: 2px;
                    background: rgba(255,255,255,0.15);
                    border-radius: 1px;
                    cursor: pointer;
                    transition: all 0.4s ease;
                    flex: 1;
                    max-width: 40px;
                    position: relative;
                    overflow: hidden;
                }

                .kq-testi-dot.active {
                    background: rgba(201,169,110,0.4);
                }

                .kq-testi-dot.active::after {
                    content: '';
                    position: absolute;
                    left: 0; top: 0; bottom: 0;
                    background: var(--gold);
                    animation: dotProgress 5s linear forwards;
                    width: 100%;
                    transform: scaleX(0);
                    transform-origin: left;
                }

                @keyframes dotProgress {
                    to { transform: scaleX(1); }
                }

                .kq-testi-view-all {
                    margin-left: auto;
                }

                /* ── RESPONSIVE ───────────────────────────────────── */
                @media (max-width: 900px) {
                    .kq-testi-stage {
                        grid-template-columns: 1fr;
                    }
                    .kq-testi-sidebar {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                    }
                    .kq-testi-card {
                        padding: 36px 28px;
                    }
                    .kq-testi-header {
                        flex-direction: column;
                        align-items: flex-start;
                    }
                }

                @media (max-width: 600px) {
                    .kq-testimonials { padding: 80px 6%; }
                    .kq-testi-sidebar { grid-template-columns: 1fr; }
                    .kq-testi-text { font-size: 18px; }
                }
            `}</style>

            <section
                className="kq-testimonials"
                onMouseEnter={() => setPaused(true)}
                onMouseLeave={() => setPaused(false)}
            >
                {/* decorative SVG filigree */}
                <svg className="kq-testi-deco" viewBox="0 0 340 340" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="0" cy="0" r="200" stroke="white" strokeWidth="0.5" />
                    <circle cx="0" cy="0" r="150" stroke="white" strokeWidth="0.5" />
                    <circle cx="0" cy="0" r="100" stroke="white" strokeWidth="0.5" />
                    <line x1="0" y1="0" x2="340" y2="0" stroke="white" strokeWidth="0.5" />
                    <line x1="0" y1="0" x2="0" y2="340" stroke="white" strokeWidth="0.5" />
                    <line x1="0" y1="0" x2="240" y2="240" stroke="white" strokeWidth="0.3" />
                </svg>
                <svg className="kq-testi-deco kq-testi-deco-br" viewBox="0 0 340 340" fill="none">
                    <circle cx="0" cy="0" r="200" stroke="white" strokeWidth="0.5" />
                    <circle cx="0" cy="0" r="150" stroke="white" strokeWidth="0.5" />
                    <circle cx="0" cy="0" r="100" stroke="white" strokeWidth="0.5" />
                    <line x1="0" y1="0" x2="340" y2="0" stroke="white" strokeWidth="0.5" />
                    <line x1="0" y1="0" x2="0" y2="340" stroke="white" strokeWidth="0.5" />
                </svg>

                <div className="kq-testi-inner">

                    {/* ── Header ── */}
                    <div className="kq-testi-header">
                        <div>
                            <p className="kq-section-eyebrow">Client Love</p>
                            <h2 className="kq-section-title light">
                                What Our <em>Guests</em> Say
                            </h2>
                        </div>

                        <div>
                            <div className="kq-testi-rating-badge">
                                <span className="kq-testi-big-num">{OVERALL_RATING}</span>
                                <div className="kq-testi-badge-right">
                                    <StarRating rating={5} />
                                    <span className="kq-testi-badge-sub">{TOTAL_REVIEWS}+ Reviews</span>
                                    <a
                                        href={GOOGLE_MAPS_URL}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="kq-testi-google-link"
                                    >
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                                        </svg>
                                        View on Google Maps
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ── Stage ── */}
                    <div className="kq-testi-stage">

                        {/* Main card */}
                        <div className={`kq-testi-card ${animating ? "fade-out" : ""}`}>
                            <div className="kq-testi-quote-icon">"</div>
                            <p className="kq-testi-text">"{r.text}"</p>
                            <div className="kq-testi-author">
                                <div className="kq-testi-avatar">{r.avatar}</div>
                                <div className="kq-testi-author-info">
                                    <span className="kq-testi-name">{r.name}</span>
                                    <div className="kq-testi-meta">
                                        <StarRating rating={r.rating} />
                                        <span className="kq-testi-service-tag">{r.service}</span>
                                        <span className="kq-testi-date">{r.date}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Sidebar mini cards */}
                        <div className="kq-testi-sidebar">
                            {REVIEWS.map((rev, i) => (
                                <div
                                    key={i}
                                    className={`kq-testi-mini ${i === active ? "active" : ""}`}
                                    onClick={() => goTo(i)}
                                >
                                    <div className="kq-testi-mini-avatar">{rev.avatar}</div>
                                    <div className="kq-testi-mini-text">
                                        <div className="kq-testi-mini-name">{rev.name}</div>
                                        <div className="kq-testi-mini-snippet">{rev.text.slice(0, 38)}…</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* ── Controls ── */}
                    <div className="kq-testi-controls">
                        <button className="kq-testi-arrow" onClick={prev} aria-label="Previous">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                <polyline points="15 18 9 12 15 6" />
                            </svg>
                        </button>

                        <div className="kq-testi-dots">
                            {REVIEWS.map((_, i) => (
                                <div
                                    key={i}
                                    className={`kq-testi-dot ${i === active ? "active" : ""}`}
                                    onClick={() => goTo(i)}
                                />
                            ))}
                        </div>

                        <button className="kq-testi-arrow" onClick={next} aria-label="Next">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                <polyline points="9 18 15 12 9 6" />
                            </svg>
                        </button>

                        <div className="kq-testi-view-all">
                            <a
                                href={GOOGLE_MAPS_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="kq-btn-gold"
                                style={{ textDecoration: "none", display: "inline-block" }}
                            >
                                All Reviews →
                            </a>
                        </div>
                    </div>

                </div>
            </section>
        </>
    );
}